import { createCustomAsyncThunk } from 'utils/createThunk'
import { providers } from 'services/endpoints'

const getProviders = createCustomAsyncThunk('providers/getProviders', 'get', providers.get_providers)
const getStaffWithAvailableTime = createCustomAsyncThunk('providers/getStaffWithShift', 'get', providers.get_staff_with_available_time)
const getStaffWithTime = createCustomAsyncThunk('providers/getStaffWithShift', 'get', providers.get_staff_with_time)

export { getProviders, getStaffWithAvailableTime, getStaffWithTime };